<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考试名称:">
          <el-input v-model="listQuery['filter[name]']" clearable placeholder="考试名称"></el-input>

        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData"  stripe style="width: 100%">
      <el-table-column prop="id" label="序号">
      </el-table-column>
      <el-table-column prop="name" label="考试名称">
      </el-table-column>
      <el-table-column   label="试卷">
        <template slot-scope="scope">
          {{ scope.row.test.name}}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="阅卷老师">
        <template slot-scope="scope">
          {{scope.row.teacher.name}}
        </template>
      </el-table-column>
      <el-table-column prop="start" label="开始时间">
      </el-table-column>
      <el-table-column prop="end" label="结束时间">
      </el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="handleEdit(scope)">查看成绩</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- v-if="pageform.total>pageform.pageSize" -->

    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page"
                  @pagination="getData"/>

    </div>
    <el-dialog :visible.sync="dialogVisible" title="成绩详情" width="80%">
      <el-table :data="theory"  stripe  >
        <el-table-column prop="id" label="序号">
        </el-table-column>
        <el-table-column prop="name" label="学生姓名">
          <template slot-scope="scope">
            {{ scope.row.student.name}}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="考试时长">
          <template slot-scope="scope">
            {{scope.row.time}}
          </template>
        </el-table-column>
        <el-table-column prop="start" label="试卷总分">
          <template slot-scope="scope">
            {{scope.row.objective+scope.row.subjective}}
          </template>
        </el-table-column>
        <el-table-column prop="objective" label="客观题得分">
        </el-table-column>
        <el-table-column prop="subjective" label="主观题得分">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'

    export default {
        components: {Pagination},
        props: {},
        data() {
            return {
                theory: [],
                examList: [],
                teacherList: [],
                testList: [],
                nameShow: 0,
                total: 0,
                dialogVisible: false,
                dialogVisible2: false,
                dialogType: 'new',
                listQuery: {
                    page: 1,
                    per_page: 20,
                    include: 'exam,test,teacher'
                },
                tableData: []
            };
        },
        computed: {},
        created() {
            this.getData();
        },
        methods: {
            search() {
                this.listQuery.page = 1;
                this.getData()
            },
            showName(value) {
                if (value == 0) {
                    this.nameShow = 1
                } else {
                    this.nameShow = 0
                }
            },
            // 获取全部的课程列表
            getData() {
                this.$http.getTheoryList(this.listQuery)
                    .then(res => {
                        this.tableData = res.data;
                        this.examList = res.exam_list;
                        this.teacherList = res.teacher_list;
                        this.testList = res.test_list;
                        this.total = res.meta.total;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            handleEdit(scope) {
                this.dialogVisible = true;
                this.$http.studentscore(scope.row.id).then(res => {
                    this.theory = res.data
                })
            },
            confirmSave() {
                const isEdit = this.dialogType === 'edit'
                if (isEdit) {
                    this.$http.updateTheory(this.theory.id, this.theory).then(res => {
                        this.dialogVisible = false
                        this.$notify({
                            title: 'Success',
                            message: '操作成功！',
                            type: 'success'
                        });
                        this.getData()
                    })
                } else {
                    this.$http.addTheory(this.theory).then(res => {
                        this.dialogVisible = false
                        this.$notify({
                            title: 'Success',
                            message: '操作成功！',
                            type: 'success'
                        })
                        this.getData()
                    })
                }
            },
            handleDelete({$index, row}) {
                this.$confirm('确定要删除此条吗?', '警告', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http.deleteTheory(row.id).then(res => {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                        });
                        this.getData()

                    })
                    .catch(err => {
                        console.error(err)
                    })
            },
        },
    };
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/theoryManage/scoreList.vue